import { render, staticRenderFns } from "./Foot685-B.vue?vue&type=template&id=5ce87f30"
import script from "./Foot685-B.vue?vue&type=script&lang=js"
export * from "./Foot685-B.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports